import React, { createRef, useEffect } from "react";
import { allProjects } from "./projectConfig";
import Details from "./Details";

export default function ProjectDetails() {
  let first = createRef();

  useEffect(() => {
    const doc = document.getElementById("details");
    doc.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }, []);

  return (
    <div
      id="details"
      className="mt-[20px] bg-white dark:!bg-darkBackground min-h-screen"
    >
      <div className="d-flex flex-column text-center">
        <h1 className="contactH">
          <span className="otherH">&lt;</span>
          <span className="getH" data-clip="Projects">
            Projects
          </span>
          <span className="otherH"> /&gt;</span>
        </h1>
        <p className="lead text-sm md:text-lg text-black/70 dark:text-white/70">
          Here are some amazing projects I have worked on
        </p>
      </div>
      <div className="all" ref={first}>
        {allProjects.map((project, index) => {
          return (
            <Details
              project={project}
              index={index}
              key={index}
              first={first}
            />
          );
        })}
      </div>
    </div>
  );
}
